import { useState, useEffect } from "react";

export default function RadioWidget({ title = "Pescobar Radio" }) {
  // Using official player and widget components from pescobar.radio code
  return (
    <div className="bg-[#090c12] border border-[#151924] overflow-hidden shadow-xl" data-testid="widget-radio">
      {/* Widget Header */}
      <div className="px-4 py-3 bg-[#06080d] border-b border-[#141824] flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse shadow-[0_0_8px_#ef4444]" />
          <h4 className="font-chakra font-bold text-xs uppercase tracking-wider text-white">{title}</h4>
        </div>
        <span className="text-[9px] font-mono text-emerald-400 uppercase tracking-widest bg-emerald-500/10 border border-emerald-500/30 px-1.5 py-0.5">
          LIVE
        </span>
      </div>

      <div className="p-3 flex flex-col items-center gap-3">
        {/* Official embedded player with theme custom colors c=#273852&c2=#C8B360 */}
        <div className="w-full flex justify-center">
          <iframe 
            src="https://player.radioking.io/pescobar/?c=%23273852&c2=%23C8B360&f=h&i=0&p=1&s=0&li=1&popup=1&plc=0&h=undefined&l=280&v=2" 
            style={{ borderRadius: "8px", width: "100%", height: "115px", maxWidth: "280px" }} 
            frameBorder="0"
            title="Pescobar Radio Player"
          />
        </div>
      </div>
    </div>
  );
}
